var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-range-input',{attrs:{"attribute":_vm.ALGOLIA_ATTRIBUTE.PRICE},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var currentRefinement = ref.currentRefinement;
var range = ref.range;
var refine = ref.refine;
var canRefine = ref.canRefine;
return [_c('PricePickerInner',{attrs:{"current-refinement":currentRefinement,"max-range":range,"can-refine":canRefine},on:{"refine":function($event){return refine($event)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }